import React from 'react';
import { Badge } from './adminUi';
import { formatSom } from '../lib/money';

const fmtPrice = formatSom;

function fmtRating(rating, count) {
  // rating null (usta hali baholanmagan) => "Reyting yo'q", 0 deb ko'rsatmaymiz.
  if (rating == null) return 'Reyting yo\'q';
  const c = count != null ? count : 0;
  return `★ ${rating}${c ? ` (${c})` : ''}`;
}

const OFFER_STATUS_LABEL = {
  pending: 'Kutilmoqda',
  accepted: 'Qabul qilindi',
  rejected: 'Rad etildi',
  cancelled: 'Bekor qilindi',
  canceled: 'Bekor qilindi',
};
const OFFER_STATUS_TONE = {
  pending: 'amber',
  accepted: 'green',
  rejected: 'red',
  cancelled: 'red',
  canceled: 'red',
};

// Bitta buyurtmaning ustalar takliflari: ism + narx + reyting. Bo'sh bo'lsa
// "Hali takliflar yo'q" — bo'sh massiv sahifani sindirmaydi.
export default function OrderOffers({ offers }) {
  if (!Array.isArray(offers) || offers.length === 0) {
    return <span style={oStyle.empty}>Hali takliflar yo'q</span>;
  }
  return (
    <div style={oStyle.list}>
      {offers.map((f) => (
        <div key={f.id} style={oStyle.item}>
          <div style={oStyle.topRow}>
            <span style={oStyle.name}>{f.masterName || '—'}</span>
            <span style={oStyle.price}>{fmtPrice(f.price)}</span>
          </div>
          <div style={oStyle.metaRow}>
            <span style={oStyle.rating}>{fmtRating(f.rating, f.ratingCount)}</span>
            <Badge tone={OFFER_STATUS_TONE[f.status] || 'gray'}>
              {OFFER_STATUS_LABEL[f.status] || f.status || '—'}
            </Badge>
          </div>
        </div>
      ))}
    </div>
  );
}

const oStyle = {
  empty: { color: 'var(--color-text-muted)', fontStyle: 'italic', fontSize: '12px' },
  list: { display: 'flex', flexDirection: 'column', gap: '8px' },
  item: {
    borderRadius: 'var(--radius-card)',
    padding: '12px',
    background: 'var(--color-surface-alt)',
  },
  topRow: { display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'baseline' },
  name: { fontSize: '14px', fontWeight: 500, color: 'var(--color-text)', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  price: { fontSize: '14px', fontWeight: 700, color: 'var(--color-text)', whiteSpace: 'nowrap', flexShrink: 0 },
  metaRow: { display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'center', marginTop: '4px' },
  rating: { fontSize: '12px', color: 'var(--color-text-muted)', whiteSpace: 'nowrap' },
};
